import React from 'react'
import styled, { css } from 'styled-components'
import AnimatedNumber from 'react-animated-number'
import { formatValue } from 'state/utils'


const NumberRenderer = value => {
  return <AnimatedNumber component="text" 
      value={parseFloat(value)}
      initialValue={parseFloat(value)}
      style={{
        transition: '2s ease-out',
      }}
      duration={500}
      formatValue={n => formatValue(n)}
      stepPrecision={2}
    />
}


export default class SensitivityTable extends React.Component {
  render() {
    const sensitivityData = this.props.sensitivityData
    const ages = (Object.keys(sensitivityData)) || []
    const afterTaxSavings = ages.length > 0 ? Object.keys(Object.values(sensitivityData)[0]) : []

    return (
        <Wrapper>
        {(ages.length > 0 && afterTaxSavings.length > 0) &&
          <SensitivityWrapper>
            <SensitivityHeading>Sensitivity</SensitivityHeading>
            <TableWrapper>
              {ages.map((age, yIndex) => {
                return(
                  <Row>
                    {afterTaxSavings.map((savings, xIndex) => {
                      return(
                        <CellWrapper>
                          <Cell>{NumberRenderer(sensitivityData[age][savings])}</Cell>
                          {(yIndex === ages.length - 1) && <Axis>{NumberRenderer(savings)}</Axis>}
                        </CellWrapper>
                      )
                    })}
                    <Axis>{age}</Axis>
                  </Row>
                )
              })}
            </TableWrapper>
            <Xlabel>After tax savings</Xlabel>
            <Ylabel>Retirement age</Ylabel>
          </SensitivityWrapper>
        }
        </Wrapper>
      )
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 35px;
`

const SensitivityWrapper = styled.div`

`

const SensitivityHeading = styled.div`
  font-size: 14px;
  font-weight: 500;
  padding-bottom: 10px;
`

const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Row = styled.div`
  flex: 1;
  display: flex;
  color: #444;
`

const baseAxis = css`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #949494;
  font-weight: 500;
`

const Ylabel = styled.div`
  position: absolute;
  transform: rotate(90deg);
  right: -54px;
  top: 735px;
  ${baseAxis};
`

const Xlabel = styled.div`
  padding-top: 5px;
  margin-right: 14px;
  ${baseAxis};
`

const Axis = styled.div`
  min-width: 14px;
  ${baseAxis}
`

const CellWrapper = styled.div`
  flex: 1;
`

const Cell = styled.div`
  margin: 2px;
  display: flex;
  font-size: 18px;
  font-weight: 300;
  background: #E4E4E4;
  min-height: 50px;
  border-radius: 2px;
  align-items: center;
  justify-content: center;
`


// WEBPACK FOOTER //
// ./sections/sensitivity-table/sensitivity-table.js